module.exports = __webpack_public_path__ + "static/media/wavIcon.f967e762.svg";